// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnifiedYourProfileSocialMediaForm = require("./UnifiedYourProfileSocialMediaForm.bs.js");
let UnifiedYourProfileSocialMediaSettingsQuery_graphql = require("../../__generated__/UnifiedYourProfileSocialMediaSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedYourProfileSocialMediaSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfileSocialMediaSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfileSocialMediaSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedYourProfileSocialMediaSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedYourProfileSocialMediaSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedYourProfileSocialMediaSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedYourProfileSocialMediaSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedYourProfileSocialMediaSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedYourProfileSocialMediaSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedYourProfileSocialMediaSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
        title: "Social Media",
        rootName: "Your Profile",
        rootUrl: "/account/profile",
        url: "/account/profile/social_media"
      }),
      JsxRuntime.jsx(UnifiedYourProfileSocialMediaForm.make, {
        agent: match.currentlyLoggedInAgent.fragmentRefs
      })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = UnifiedYourProfileSocialMediaSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
